const sx = {
  formCard: {
    backgroundColor: 'rgba(28, 44, 69, 0.45)',
    backdropFilter: 'blur(8px)',
    borderRadius: '16px',
    p: { xs: 3, md: 4 },
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
    color: 'white',
  },
  formTitle: {
    fontWeight: 600,
    fontSize: { xs: '1.1rem', md: '1.25rem' },
    mb: 3,
    '& span': {
      fontWeight: 800,
    },
  },
  label: {
    display: 'block',
    fontSize: '0.8rem',
    fontWeight: 500,
    mb: 0.5,
    color: '#E5E7EB',
  },
  inputBase: {
    backgroundColor: 'white',
    borderRadius: '4px',
    width: '100%',
    '& .MuiInputBase-input': {
      padding: '10px 14px',
      fontSize: '0.9rem',
      color: '#1F2937',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none', // Quitamos el borde por defecto de MUI
    },
  },
  selectBase: {
    backgroundColor: 'white',
    borderRadius: '4px',
    width: '100%',
    '& .MuiSelect-select': {
      padding: '10px 14px',
      fontSize: '0.9rem',
      color: '#6B7280',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
  submitBtn: {
    background: 'linear-gradient(90deg, #FD9030 0%, #FD1C54 100%)',
    color: 'white',
    borderRadius: '50px',
    py: 1.5,
    fontWeight: 700,
    fontSize: '1rem',
    textTransform: 'none',
    width: '100%',
    mt: 2,
    boxShadow: '0 4px 14px rgba(253, 28, 84, 0.4)',
    '&:hover': {
      background: 'linear-gradient(90deg, #f38423 0%, #dd0e42 100%)',
    },
    '&.Mui-disabled': {
      background: 'rgba(255, 255, 255, 0.12)',
      color: 'rgba(255, 255, 255, 0.3)',
      boxShadow: 'none',
    },
  },
}

export default sx
